<template>
  <div id="app">
    <AppHeader />
    <router-view  v-if="isClient" />
    <AppFooter v-if="showFooter" />

    <!-- 全局模态弹窗 -->
    <CustomModal 
      :visible="globalModal.visible"
      :title="globalModal.title"
      :message="globalModal.message"
      :confirm-text="globalModal.confirmText"
      :type="globalModal.type"
      :modal="globalModal.modal"
      :duration="globalModal.duration"
      :show-header="globalModal.showHeader"
      :show-footer="globalModal.showFooter"
      @confirm="handleGlobalModalConfirm"
      @close="handleGlobalModalClose"
    />

  </div>
</template>

<script>
import AppHeader from './components/Header.vue'
import AppFooter from './components/Footer.vue'
import CustomModal from './components/CustomModal.vue'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter,
    CustomModal,
  },
  data() {
    return {
      isClient: false , // 新增：客户端标识
      showConfigModal: false,
      showDropdown: false,
      dropdownHideTimeout: null,
      // 使登录状态成为响应式数据，避免直接读取 localStorage（无法被 Vue 追踪）
      isLoggedInFlag: !!localStorage.getItem('authToken'),
      // 全局模态弹窗数据
      globalModal: {
        visible: false,
        title: '提示',
        message: '',
        confirmText: '确定',
        type: 'modal', // 'modal' 或 'toast'
        modal: true, // 仅对modal类型有效，true为模态，false为非模态
        duration: 3000, // 仅对toast类型有效，单位毫秒
        showHeader: true,
        showFooter: true,
        onConfirm: null,
        onCancel: null,
        onClose: null
      }
    }
  },
  computed: {
    showFooter() {
      // 当路由不是/blog时显示Footer
      return this.$route.path !== '/blog';
    }
  },
  mounted() {
    // 在浏览器环境设置客户端标识
    this.isClient = true;
    
    // 仅在浏览器环境执行 DOM 操作
    if (typeof document !== 'undefined') {
      this.setupNavigation();
      window.addEventListener('show-global-modal', (event) => {
        this.showGlobalModal(event.detail);
      });
    }
  },
  methods: {
        // 全局模态弹窗方法
    showGlobalModal(options) {
      // 设置默认值
      const defaults = {
        title: '提示',
        message: '',
        confirmText: '确定',
        type: 'modal', // 'modal' 或 'toast'
        modal: true, // 仅对modal类型有效，true为模态，false为非模态
        duration: 3000, // 仅对toast类型有效，单位毫秒
        showHeader: true,
        showFooter: true,
        onConfirm: null,
        onCancel: null,
        onClose: null
      };
      
      // 合并选项
      const opts = { ...defaults, ...options };
      
      // 更新全局模态弹窗数据
      this.globalModal = {
        visible: true,
        title: opts.title,
        message: opts.message,
        confirmText: opts.confirmText,
        type: opts.type,
        modal: opts.modal,
        duration: opts.duration,
        showHeader: opts.showHeader,
        showFooter: opts.showFooter,
        onConfirm: opts.onConfirm,
        onCancel: opts.onCancel,
        onClose: opts.onClose
      };
    },
    
    handleGlobalModalConfirm() {
      // 处理确认事件
      this.globalModal.visible = false;
      // 如果有自定义确认回调，执行它
      if (this.globalModal.onConfirm) {
        this.globalModal.onConfirm();
      }
    },
    
    handleGlobalModalClose() {
      // 处理关闭事件
      this.globalModal.visible = false;
      // 如果有自定义关闭回调，执行它
      if (this.globalModal.onClose) {
        this.globalModal.onClose();
      }
    },
    
    // 修复：确保在浏览器环境执行 DOM 操作
    setupNavigation() {
      if (typeof document === 'undefined') return;
      
      // 点击外部区域关闭下拉菜单
      document.addEventListener('click', (event) => {
        const dropdown = this.$el.querySelector('.dropdown');
        const navLinks = this.$el.querySelectorAll('nav a');
        let isNavClick = false;
        
        for (let i = 0; i < navLinks.length; i++) {
          if (navLinks[i].contains(event.target)) {
            isNavClick = true;
            break;
          }
        }
        
        if (!isNavClick && dropdown && !dropdown.contains(event.target)) {
          this.showDropdown = false;
        }
      });
    }
  },
}
</script>

<style>
/* 全局样式 */
body {
  margin: 0;
  padding: 0;
  font-family: 'Hanken Grotesk', sans-serif;
}

* {
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 10px;
  border: none;
  cursor: pointer;
}

.btn-primary {
  background-color: #ff5f5f;
  color: white;
}

.btn-primary:hover {
  background-color: #ff4b4b;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 95, 95, 0.3);
}

.btn-secondary {
  background-color: transparent;
  border: 2px solid #667eea;
  color: #667eea;
}

.btn-secondary:hover {
  background-color: rgba(102, 126, 234, 0.1);
  transform: translateY(-2px);
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #333;
}

.section-subtitle {
  text-align: center;
  font-size: 1.2rem;
  color: #f5f3f3;
  margin-bottom: 60px;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1rem;
  }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}


</style>